import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

const glowVariants = cva('', {
  variants: {
    variant: {
      ellipse: 'rounded-[50%]',
      circle: 'rounded-full',
    },
    aspectRatio: {
      'square': 'aspect-square',
      '428-280': 'aspect-[428/280]',
    },
    bgColor: {
      gold: 'bg-gold',
      accentSec: 'bg-accent-sec',
      irrigoPurple: 'bg-irrigo-purple',
      blue: 'bg-blue',
    },
  },
});

interface GlowProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof glowVariants> {}

const Glow = forwardRef<HTMLSpanElement, GlowProps>(
  ({ variant, aspectRatio, bgColor, ...props }, ref) => {
    return (
      <span
        {...props}
        ref={ref}
        className={cn(
          glowVariants({ variant, aspectRatio, bgColor }),
          props.className,
          'absolute',
        )}
      ></span>
    );
  },
);

type GlowColorVariantsType = VariantProps<typeof glowVariants>['bgColor'];

export { Glow, type GlowColorVariantsType };
